import { Action, Mutation, getModule, Module, MutationAction, VuexModule } from "vuex-module-decorators";
import store from "@/store";
import { PaginationRequestType } from "@/entity/common/pagination.types";
import { ICity, CityResponseType, City, DataEntity } from "@/entity/territory/territory.types";

import { prepareFormData } from "@/store/utils/formDataHelper";
import { IStoreReady } from "@/store/lib/storeSupport";

@Module({
    namespaced: true,
    name: "territory",
    store,
    dynamic: true,
})
class TerritoryModule extends VuexModule implements IStoreReady {
    /*public cities: CityResponseType = {data: [], total: 0}
    public city: ICity | null = null*/
    cities: City | null = null;
    city: DataEntity | null = null;

    public cityLoaded = false;
    public citiesLoaded = false;
    ready = false;

    @Mutation
    async setReady(st: boolean) {
        this.ready = st;
    }

    @MutationAction
    async fetchAll(data?: PaginationRequestType): Promise<{ cities: City; citiesLoaded: boolean }> {
        let citiesLoaded = false;
        const cities = await store.$repository.territory.fetchAll(prepareFormData(data));
        if (cities) {
            citiesLoaded = true;
        }
        return { cities, citiesLoaded };
    }
    @MutationAction
    async fetchData(data: PaginationRequestType): Promise<{ city: DataEntity; cityLoaded: boolean }> {
        let cityLoaded = false;
        const city = await store.$repository.territory.fetchData(data);
        if (city) {
            cityLoaded = true;
        }
        return { city, cityLoaded };
    }

    /*@MutationAction
    async fetchCity(data?: PaginationRequestType): Promise<{cities: CityResponseType; citiesLoaded: boolean}> {
        const cities = await store.$repository.territory.fetchCity(data);
        let citiesLoaded = false;
        if (cities.total !== 0) {
            citiesLoaded = true;
        }
        return {cities, citiesLoaded};
    }*/

    /*@MutationAction
    async fetchRegion(data?: PaginationRequestType): Promise<{regions: IRegion[]; regionsLoaded: boolean}> {
        const regions = await store.$repository.territory.fetchRegion();
        let regionsLoaded = false;
        if (regions.length !== 0) {
            regionsLoaded = true;
        }
        return {regions, regionsLoaded};
    }*/
}

export const TerritoryStore = getModule(TerritoryModule);
